<app-ui-blocker [state]="loadingState" [loadingImage]="loadingImage">
    @if (showContent) {
        <div>
            <ng-content></ng-content>
        </div>
    }
</app-ui-blocker>
